const ResourceManage = () => import('@/views/main/voice/phone/ResourceManage.vue')
export default {
  path: '/main/voice/phone',
  name: 'ResourceManage',
  component: ResourceManage,
  children: []
}
